import styled from 'styled-components'

import CardContent from '@material-ui/core/CardContent'

import colors from '@galo-monitor/styles/colors'
import Card from '@galo-monitor/web-components/Card'

export const Container = styled(Card).attrs({
  headerStyle: {
    padding: '5px 16px 5px',
    alignText: 'left',
    backgroundColor: colors.backgroundHtml
  },
  cardStyle: { padding: 0, width: '100%', boxShadow: 'none' },
  cardContentProps: { style: { padding: '5px 0' } }
})`
  width: 100%;
  margin: 0;
`

export const Content = styled(CardContent)`
  padding-top: 0;
`
